// extracted by mini-css-extract-plugin
module.exports = {"avatar-wrap":"author-avatar_avatar-wrap__1pWQN","name":"author-avatar_name__3ex3-"};